<h2><span i18n="@@titleDiagnostics">Diagnostics</span>&nbsp;<span i18n="@@Charger">Charger</span> {{ chargerId }}</h2>

@if (chargerPropertiesLoaded()) {
    <div class="card-container">
        @for (section of chargerPropertySections; track section.title) {
            <mat-card class="mat-elevation-z5">
                <mat-card-header>
                    <mat-card-title>{{ section.title }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-list>
                        @for (property of section.items; track property.name) {
                            <mat-list-item>
                            <div class="item-block">
                                <div class="line-top">{{property.name}}</div>
                                <div class="title-bottom">{{property.value}}</div>
                            </div>
                            </mat-list-item>
                        }
                    </mat-list>
                </mat-card-content>
            </mat-card>
        }
    </div>
} @else {
    <mat-spinner />
}
